import { branding } from '@/config/branding'
import { cn } from '@/lib/utils'

interface BrandFooterProps {
	className?: string
	'data-testid': string
}

/** The deployment copyright line under the unauthenticated pages. */
export function BrandFooter({ className, 'data-testid': dataTestId }: BrandFooterProps) {
	return (
		<footer className={cn('mt-8 text-center text-control text-muted-foreground', className)} data-testid={dataTestId}>
			{branding.copyrightText.split('{year}').join(String(new Date().getFullYear()))}
		</footer>
	)
}
